// @ts-nocheck — W2.1 in-place migration: TS strict aplicado em waves subsequentes
import React, { Component } from "react";

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import MultiPoint from 'ol/geom/MultiPoint';

import Style from "ol/style/Style.js";
import Fill from "ol/style/Fill.js";
import Stroke from "ol/style/Stroke.js";
import CircleStyle from "ol/style/Circle";


import GeomUtils from '../geocloud/GeomUtils';
import { Popover, Divider } from "antd";
import { IconRuler, IconX } from "@tabler/icons-react";
const FontAwesomeIcon = ({ icon }: { icon: string }) => {
  if (icon === "ruler-combined") return <IconRuler size={14} />;
  if (icon === "times") return <IconX size={14} />;
  return null;
};
import { formatGMSWithSymbols } from '../../utils';

class MeasureTool extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
    };

    //styles
    this._defaultStyle = {};

    this._defaultStyle["polygon"] = new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.3)'
      }),
      stroke: new Stroke({
        color: 'rgba(255, 0, 0, 0.7)',
        width: 2
      }),
      image: new CircleStyle({
        radius: 3.5,
        stroke: new Stroke({
          color: 'rgba(255, 0, 0, 1)'
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 255, 1)'
        })
      })
    });

    //private props

    this._source = new VectorSource({
      useSpatialIndex: false,
      wrapX: false
    });

    this._layer = new VectorLayer({
      source: this._source,
      updateWhileInteracting: true
    });

    this._map = null;

    this._feature = null;
    this._vertexFeature = null;

    this._type = "polygon"; //polygon, polyline, point
    this._datum = 'WGS84'; //SAD69, WGS84, SIRGAS2000
    this._format = 'GDEC'; //GDEC, GMS, UTM
    this._useNSEW = false;
    this._coords = [];

    this._tooltips = [];
    this._lastXY = [-1, -1];

    //refs
    this.renderedRef = React.createRef();
  }


  componentWillUnmount() {
    this.deactivate();
  }


  deactivate = () => {

    if (!this.state.active)
      return;

    //geometry layer
    this.clearFeatures();

    //event unbind
    if (this._map) {
      this.props.activateIdentify();
      this._map.un('click', this.onMapClick);
      this._map.getTargetElement().removeEventListener('mousemove', this.onMouseMove);
      this._map.getTargetElement().removeEventListener('mouseout', this.onMouseOut);
    }

    document.removeEventListener('keydown', this.onKeyDown);

    //reset
    this._coords = [];
    this._tooltips = [];
    this._map = null;

    this.setState({ active: false });
  }

  activate = () => {

    if (this.state.active)
      return;

    if (this.props.onPreActivate)
      this.props.onPreActivate();

    this._map = this.props.getMap();

    if (!this._map)
      return;

    //geometry layer
    this.initializeFeatures();

    //event bind
    this.props.deactivateIdentify();

    this._map.on('click', this.onMapClick);
    this._map.getTargetElement().addEventListener('mousemove', this.onMouseMove);
    this._map.getTargetElement().addEventListener('mouseout', this.onMouseOut);

    document.addEventListener('keydown', this.onKeyDown);

    this.setState({ active: true });
  }

  handleVisibleChange = active => {
    if (active)
      this.activate();
    else
      this.deactivate();
  };




  initializeFeatures = () => {

    this._feature = new Feature({
      geometry: new Polygon([this._coords])
    });

    this._vertexFeature = new Feature({
      geometry: new MultiPoint(this._coords)
    });

    this._source.clear();

    if (this._feature)
      this._source.addFeature(this._feature);

    this._source.addFeature(this._vertexFeature);

    this._layer.setMap(this._map);
    this._layer.setZIndex(2001);
    this._layer.setStyle(this._defaultStyle[this._type]);
  }

  clearFeatures = () => {
    this._feature = null;
    this._vertexFeature = null;

    this._tooltips.forEach(overlay => this._map.removeOverlay(overlay));
    this._tooltips = [];

    this._source.clear();
    this._layer.setMap(null);
  }

  updateFeatureCoordinates = () => {
    this._feature.getGeometry().setCoordinates([this._coords]);
    this._vertexFeature.getGeometry().setCoordinates(this._coords);

    this.forceUpdate();
  }



  addCoordinate = (coord) => {
    if (this._coords.length) {
      const last = this._coords[this._coords.length - 1];

      if (Math.abs(last[0] - coord[0]) < 0.5 && Math.abs(last[1] - coord[1]) < 0.5)
        return;
    }

    this._coords.push(coord);
    this.updateFeatureCoordinates();
  }

  onMouseOut = (event) => {
    this._lastXY[0] = - 1;
    this._lastXY[1] = - 1;
  }

  onMouseMove = (event) => {
    this._lastXY[0] = event.offsetX;
    this._lastXY[1] = event.offsetY;
  }

  onMapClick = (event) => {
    this.addCoordinate(event.coordinate);
  }

  onKeyDown = (event) => {
    const invalidTargets = ['SELECT', 'INPUT'];
    if (event.target && invalidTargets.includes(event.target.tagName))
      return;

    switch (event.keyCode) {
      case 32:
        //space
        event.preventDefault();

        if (this._lastXY[0] < 0 || this._lastXY[1] < 0 || this.props.isPanning())
          return;

        var coord = this._map.getCoordinateFromPixel(this._lastXY);

        this.addCoordinate(coord);
        break;

      case 46:
      case 68:
        //delete, key D
        event.preventDefault();

        if (!this._coords.length)
          return;

        this._coords.pop();
        this.updateFeatureCoordinates();

        break;
      default:
        break;
    }
  }


  renderContent = () => {
    var ordinates = [];
    this._coords.forEach(item => {
      const lonLat = GeomUtils.fromWebMercator(item);
      ordinates.push(lonLat[0]);
      ordinates.push(lonLat[1]);
    });


    var length = 0;
    var perimeter = 0;
    var area = 0;
    
    var lastOrdinates = [];

    if (ordinates.length > 0) {
      var utmZone = GeomUtils.getUTMZone(ordinates[0]);
      var hemSouth = GeomUtils.isSouthHemisphere(ordinates[1]);

      lastOrdinates.push(ordinates[ordinates.length-2]);
      lastOrdinates.push(ordinates[ordinates.length-1]);

      GeomUtils.toUTM(ordinates, 'WGS84', utmZone, hemSouth, true);

      length = GeomUtils.measureLength(ordinates);
      area = GeomUtils.measureArea(ordinates);
      perimeter = GeomUtils.measurePerimeter(ordinates);
    }

    

    return (
      <div className="measure-info">
        <div>
          <div className='header'>Medir áreas e distâncias</div>
          <a href="#!" className="pull-right" onClick={(e) => { e.preventDefault(); this.handleVisibleChange(false); }}><FontAwesomeIcon  icon="times" /></a>
        </div>
        

        { lastOrdinates.length > 0 &&
          <spam>
            <Divider />

            <div className='flex-vertical'>
              <div className='header'>Último ponto (Geográfico SIRGAS 2000)</div>
            </div>

            <div className='flex-vertical'>
              <div className='flex-vertical full-width'>  
                <div className='text-right'>Long: { formatGMSWithSymbols(lastOrdinates[0]) }</div>
                <div className='text-right'>/ Lat: { formatGMSWithSymbols(lastOrdinates[1], true) }</div>
              </div>
            </div>

            <div className='flex-vertical'>
              <div className='flex-vertical full-width'>  
                <div className='text-right'>Long: {lastOrdinates[0].toLocaleString('pt-BR', { minimumFractionDigits: 6, maximumFractionDigits: 6 }) } </div>
                <div className='text-right'>/ Lat: {lastOrdinates[1].toLocaleString('pt-BR', { minimumFractionDigits: 6, maximumFractionDigits: 6 } )}</div>
              </div>
            </div>
          </spam>
        }

        <Divider />

        { ordinates.length <= 0 &&
          <div className='flex-vertical'>
            <div>Adicione um ponto no mapa</div>            
          </div>
        }

        { ordinates.length > 0 &&
          <spam>
            <div className='flex-vertical'>
              <div className='header'>Comprimento</div>
              <div className='flex-vertical full-width'>
                <div className='text-right'>{(length / 1000).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} km</div>
                <div className='text-right'>{length.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m</div>
                <div className='text-right'></div>
              </div>
            </div>

            <Divider />

            <div className='flex-vertical'>
              <div className='header'>Área</div>
              <div className='flex-vertical full-width'>
                <div className='text-right'>{(area / 1000000).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} km²</div>
                <div className='text-right'>{(area / 10000).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ha</div>
                <div className='text-right'>{area.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m²</div>
              </div>
            </div>

            <Divider />

            <div className='flex-vertical'>
              <div className='header'>Perímetro</div>
              <div className='flex-vertical full-width'>
                <div className='text-right'>{(perimeter / 1000).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} km</div>
                <div className='text-right'>{perimeter.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m</div>
                <div className='text-right'></div>
              </div>
            </div>
          </spam>
        }
      </div>
    );
  }

  render() {

    return (
      <div ref={this.renderedRef}>
        <div className="ol-control ol-unselectable btn-measure">
          <Popover placement="topLeft" /*rightBottom*/
            trigger="click"
            visible={this.state.active}
            onVisibleChange={this.handleVisibleChange}
            content={this.renderContent()}>
            <button title="Medir áreas e distâncias">
              <FontAwesomeIcon icon="ruler-combined" />
            </button>
          </Popover>
        </div>
      </div>
    );
  }

}

export default MeasureTool;